import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import db from "../../utils/firebase.config";
import "./style.css";

const QrConfirmation = () => {
  const { invitationId, guessId, wardId } = useParams();
  const [guest, setGuest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const ref = doc(db, `invitation/${invitationId}/guess/${guessId}`);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          setError("Invitación no encontrada");
          return;
        }

        const data = snap.data();

        if (wardId !== "null") {
          const ward = data.wards?.find((w) => w.id === parseInt(wardId));
          ward ? setGuest(ward) : setError("Acompañante no encontrado");
        } else {
          setGuest(data);
        }
      } catch (err) {
        console.error("qr confirmation error", err);
        setError("Error al cargar la invitación. Verifica tu conexión.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [invitationId, guessId, wardId]);

  return (
    <section id="qr-confirm">
      <div className="qrc-body">

        {/* Branding */}
        <div className="qrc-header">
          <p className="qrc-monogram">L &amp; M</p>
          <div className="qrc-rule" />
          <h1 className="qrc-names">Lucero &amp; Miguel</h1>
          <p className="qrc-date">19 · Septiembre · 2026</p>
        </div>

        <div className="qrc-divider" />

        {/* Loading */}
        {loading && (
          <div className="qrc-loading">
            <span className="qrc-dot" />
            <span className="qrc-dot" />
            <span className="qrc-dot" />
          </div>
        )}

        {/* Error */}
        {!loading && error && (
          <div className="qrc-status-block qrc-status-block--error">
            <span className="qrc-icon">✕</span>
            <p className="qrc-status-label">No encontrado</p>
            <p className="qrc-error-detail">{error}</p>
          </div>
        )}

        {/* Guest found */}
        {!loading && guest && (
          <>
            <div className={`qrc-status-block ${guest.confirmed ? "qrc-status-block--ok" : "qrc-status-block--pending"}`}>
              <span className="qrc-icon">
                {guest.confirmed ? "✓" : "○"}
              </span>
              <p className="qrc-status-label">
                {guest.confirmed ? "CONFIRMADO" : "SIN CONFIRMAR"}
              </p>
            </div>

            <div className="qrc-divider" />

            <div className="qrc-guest-info">
              <p className="qrc-guest-name">{guest.name}</p>
              {guest.table ? (
                <p className="qrc-guest-table">Mesa · {guest.table}</p>
              ) : (
                <p className="qrc-guest-notable">Sin mesa asignada</p>
              )}
            </div>
          </>
        )}

      </div>
    </section>
  );
};

export default QrConfirmation;
